/* eslint-disable indent */
import { ChartConfiguration, ChartData, ChartDataSets } from 'chart.js';
import { ghsFormatter } from 'utils/formatters';

interface IArgs {
  dataItems: ChartDataSets['data'] | string[];
  labels: ChartData['labels'];
  xlMore: boolean;
}

export const chartConfig = ({ dataItems, labels, xlMore }: IArgs): ChartConfiguration => {
  const showEmpty = !dataItems;
  const colors = ['#D1199E', '#F7E103', '#5D00F9', '#31C9C0', '#9A9DAF'];

  return {
    type: 'doughnut',
    data: {
      labels,
      datasets: [
        showEmpty
          ? {
              label: '',
              backgroundColor: colors,
              borderWidth: 0,
              data: [0, 0, 0, 0, 1],
            }
          : {
              data: dataItems as number[],
              backgroundColor: colors,
              borderWidth: 0,
              hoverBorderWidth: 2,
              hoverBorderColor: '#FFFFFF',
            },
      ],
    },
    options: {
      title: {
        display: false,
      },
      tooltips: showEmpty
        ? { enabled: false }
        : {
            backgroundColor: '#FFFFFF',
            bodyFontSize: xlMore ? 12 : 10,
            bodyFontFamily: "'EtelkaTextPro', 'Helvetica Neue', helvetica, arial, sans-serif",
            bodyFontColor: '#222736',
            xPadding: 8,
            displayColors: false,
            cornerRadius: 4,
            caretSize: 0,
            caretPadding: 0,
            callbacks: {
              label(tooltipItem, tooltipData) {
                const { datasetIndex, index } = tooltipItem;
                const data = dataItems as number[];
                const dataSum = data.reduce((a: number, b: number) => a + b, 0);
                const value = +(tooltipData?.datasets?.[datasetIndex ?? -1].data?.[index ?? -1] ?? NaN);
                const percentage = `${Math.round((value / dataSum) * 100)}%`;
                return `${ghsFormatter.format(value)} - ${percentage}`;
              },
            },
          },
      legend: {
        display: false,
      },
      legendCallback: (chart) => {
        const renderLabels = (innerChart: Chart) => {
          const { data } = innerChart;
          // const dataitems = data?.datasets?.[0].data as number[];

          if (labels) {
            return labels
              .map(
                (_, i: number): string =>
                  `<li>
              <div id="legend-${i}-item" class="legendItem">
                <span style="background-color: ${String(data?.datasets?.[0].backgroundColor?.[i])}">
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                ${String(data?.labels?.[i]) && `<span class="label">${String(data?.labels?.[i])}</span>`}
              </div>
            </li>`,
              )
              .join('');
          }

          return '';
        };
        return `<ul>${renderLabels(chart)}</ul>`;
      },
      responsive: true,
      aspectRatio: 1,
      cutoutPercentage: 75,
    },
  };
};

export const bindChartEvents = (myChart: Chart, containerElement: Document | Element) => {
  const legendItemSelector = '.legendItem';
  const labelSelector = '.label';

  const legendItems = containerElement.querySelectorAll(legendItemSelector);
  const updateDataset = (currentEl: (Node & ParentNode) | null | undefined, index: number) => {
    const meta = myChart.getDatasetMeta(0);
    const labelEl = currentEl?.querySelector<HTMLElement>(labelSelector);
    const result = !meta.data[index].hidden;
    if (labelEl) {
      labelEl.style.textDecoration = result ? 'line-through' : 'none';
    }
    meta.data[index].hidden = result;
    myChart.update();
  };
  legendItems.forEach((item, i) => {
    item.addEventListener('click', (e) => updateDataset((e.target as Element | null)?.parentNode, i));
  });
};
